<template>
  <div class="font-poppin">
        <div class="filter-header header-bgcolor">
            <div class="fs-14 font-weight-bold ml-4">Filters (<span style="color:#ffba00 !important;">{{totalFilters}}</span>)</div>
            <div class="pointer">
                <el-tooltip class="item" effect="dark" content="Back" placement="top">
                    <span @click="closeFilters()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ArrowBgBlue.svg" alt="arrow">
                    </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Reset" placement="top">
                    <span @click="resetFilter()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/ResetBgBlue.svg" alt="reset">
                    </span>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Close" placement="top">
                    <span @click="closeFilters()">
                        <img class="filter-Images" src="https://cdn.digicollect.com/cdn/scmnew/images/scm/CloseBgBlue.svg" alt="close">
                    </span>
                </el-tooltip>
            </div>
        </div>
        <div class="container filter-content">
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-secondary font-weight-bold">Fiscal Year</span>
                        <multiselect :limit="1" :limit-text="limitFiscalYear" placeholder="Select Fiscal Year" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="fiscal_year" :options="fiscal_year_options" :multiple="true" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" @close="update()">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer" @click="removeFiscalYear(option)">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Fiscal Years Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-secondary font-weight-bold">Target Amount ({{currency}})</span>
                        <multiselect placeholder="Select Range" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="target_amount" :options="amount_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" @close="update()">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Target Amount Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-secondary font-weight-bold">Achieved Amount ({{currency}})</span>
                        <multiselect :limit="1" placeholder="Select Range" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="achieved_amount" :options="amount_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" @close="update()">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Achieved Amount Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-secondary font-weight-bold">Pipeline Amount ({{currency}})</span>
                        <multiselect placeholder="Select Range" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="pipeline_amount" :options="amount_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" @close="update()">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Pipeline Amount Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-lg-6 col-md-6 col-sm-12">
                    <div class="group-setup mt-6">
                        <span class="fs-14 text-secondary font-weight-bold">Target Increment</span>
                        <multiselect :limit="1" placeholder="Select Range" class="digi-multiselect approval-manager filter-multiple mt-2" v-model="target_increment" :options="amount_options" :multiple="false" :searchable="true" :internal-search="true" :clear-on-select="false" :close-on-select="true" :options-limit="3000" :max-height="200" :show-no-results="true" :hide-selected="false" @close="update()">
                            <template slot="tag" slot-scope="{ option }">
                                <span class="custom__tag">
                                <span class="filterSelectedName">{{ option }}</span>
                                    <span class="custom__remove pointer">
                                        <i class="icon icon-close fs-16 text-white"></i>
                                    </span>
                                </span>
                            </template>
                            <template slot="noOptions">
                                <div class="text-secondary text-center font-weight-bold">Target Increment Not Found</div>
                            </template>
                            <template slot="noResult">
                                <div class="text-secondary text-center fw-600">No Data Found</div>
                            </template>
                        </multiselect>
                    </div>
                </div>
            </div> -->
        </div>
    </div>
</template>
<script>
import { EventBus } from '../eventBus/nav-bar-event';
export default {
    data() {
    return {
    fiscal_year: [],
    currency:'',
    target_amount: "",
    achieved_amount: "",
    pipeline_amount: "",
    target_increment: "",
    fiscal_year_options: [
        '2022 - 2023',
        '2023 - 2024',
        '2024 - 2025',
        '2025 - 2026',
        '2026 - 2027',
        '2027 - 2028',
        '2028 - 2029',
        '2029 - 2030',
        '2030 - 2031',
        '2031 - 2032',
        '2032 - 2033',
        '2033 - 2034',
        '2034 - 2035',
        '2035 - 2036',
        '2036 - 2037',
        '2037 - 2038',
        '2038 - 2039',
        '2039 - 2040',
        '2040 - 2041',
        '2041 - 2042',
        '2042 - 2043',
        '2043 - 2044',
        '2044 - 2045'
    ],
    amount_options: ['0-1000','1000-5000','5000-10000','10000-50000','50000-100000','100000-200000'],
    value_target_amount: 0,
    value_achieved_amount: 0,
    value_pipeline_amount: 0,
    value_target_increment: 0
    }
    },
    methods: {
        limitFiscalYear(count){
            return `+ ${count} more`
        },
        closeFilters(){
            this.hide_filters = false
            this.$emit('hideFilters')
        },
        removeFiscalYear(option){
            this.fiscal_year.forEach((el,index)=>{
                if(el == option){
                    this.fiscal_year.splice(index,1)
                }
            })
        },
        removeTargetAmount(){
            this.target_amount = ""
        },
        removeAchievedAmount(){
            this.achieved_amount = ""
        },
        removePipelineAmount(){
            this.pipeline_amount = ""
        },
        update(){
            let params = {
                target_amount: this.target_amount || "",
                achieved_amount: this.achieved_amount || "",
                pipeline_amount: this.pipeline_amount || "",
                fiscal_year: this.fiscal_year,
            }
            let newData = {
                value:params,
            }
            this.$emit('UpdateByFilter',newData)
        },
        resetFilter(){
            if(this.totalFilters > 0){
                this.fiscal_year = []
                this.target_amount = ""
                this.achieved_amount = ""
                this.pipeline_amount = ""
                this.target_increment = ""
                this.update()
            }
        }
    },
    async mounted(){
        EventBus.$on('removechip',params=>{
            if(params.key == 'fiscal_year'){
                this.removeFiscalYear(params.value)
                this.update()
            }else if(params.key == 'target_amount'){
                this.removeTargetAmount(params.value)
                this.update()
            }else if(params.key == 'achieved_amount'){
                this.removeAchievedAmount(params.value)
                this.update()
            }else if(params.key == 'pipeline_amount'){
                this.removePipelineAmount(params.value)
                this.update()
            }
        })
        EventBus.$on('removeAllchip',() => {
            this.resetFilter()
        })
        this.currency = this.loggedInUser.currency.symbol;
    },
    destroyed(){
        EventBus.$off('removechip')
        EventBus.$off('removeAllchip')
    },
    computed:{
        totalFilters(){
            if(this.target_amount){
                this.value_target_amount = 1
            }
            else{
                this.value_target_amount = 0
            }
            if(this.achieved_amount){
                this.value_achieved_amount = 1
            }
            else{
                this.value_achieved_amount = 0
            }
            if(this.pipeline_amount){
                this.value_pipeline_amount = 1
            }
            else{
                this.value_pipeline_amount = 0
            }
            if(this.target_increment){
                this.value_target_increment = 1
            }
            else{
                this.value_target_increment = 0
            }
            return this.fiscal_year.length + this.value_target_amount + this.value_achieved_amount + this.value_pipeline_amount + this.value_target_increment
        },
        loggedInUser() {
            return this.$store.state.loggedInUser;
        }
    }
}
</script>

<style scoped>
.header-bgcolor {
    background-color: #00448b !important;
}
.text-secondary {
    color: #0d84f2;
}
.filter-content {
    max-height: 400px !important;
    overflow: visible;
}
</style>


// WEBPACK FOOTER //
// src/components/SalesForeCast/HistoricalFilter.vue